// src/components/VideoPlayer.js
import React, { useEffect, useRef } from "react";
import Plyr from "plyr";
import "plyr/dist/plyr.css";

export default function VideoPlayer({ src, poster, title }) {
  const videoRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      if (playerRef.current) {
        playerRef.current.destroy();
      }

      playerRef.current = new Plyr(videoRef.current, {
        controls: [
          "play",
          "progress",
          "current-time",
          "mute",
          "volume",
          "settings",
          "fullscreen",
        ],
        settings: ["quality", "loop"],
        quality: {
          default: 720,
          options: [144, 240, 360, 480, 720, 1080],
          forced: true,
        },
      });
    }

    return () => {
      if (playerRef.current) playerRef.current.destroy();
    };
  }, [src]);

  return (
    <div className="plyr-container">
      <video
        ref={videoRef}
        className="plyr-video-element"
        playsInline
        controls
        poster={poster || ""}
      >
        <source src={src} type="video/mp4" />
        <source src={src} type="video/webm" />
      </video>

      {title && <p className="plyr-title">{title}</p>}
    </div>
  );
}
